<template>
    <a
        v-if="isSubdomain"
        :href="
            $page.props.language == 'fr'
                ? `${$page.props.appUrl}/emplois/${offer.slug}`
                : `${$page.props.appUrl}/job-opportunities/${offer.slug}`
        "
        class="group flex flex-col space-y-6 rounded-md border bg-white p-6 shadow"
        :class="[offer.promoted ? 'border-t-4 border-green-600 hover:border-t-4 hover:border-green-600' : '']"
        target="_blank"
        rel="noopener noreferrer"
    >
        <div>
            <a
                :href="
                    $page.props.locale == 'fr'
                        ? `${$page.props.appUrl}/emplois/${offer.slug}`
                        : `${$page.props.appUrl}/job-opportunities/${offer.slug}`
                "
                class="block text-2xl font-bold leading-tight hover:underline"
                target="_blank"
                rel="noopener noreferrer"
            >
                {{ offer.title }}
            </a>

            <InertiaLink
                :href="
                    $page.props.locale == 'fr'
                        ? `${$page.props.appUrl}/emplois?entreprise=${offer.company_slug}`
                        : `${$page.props.appUrl}/job-opportunities?entreprise=${offer.company_slug}`
                "
                class="font-semibold hover:underline"
            >
                {{ offer.company?.name }}
            </InertiaLink>
        </div>

        <div class="flex flex-col space-y-1 text-gray-600">
            <div
                v-if="offer.city && offer.city.length > 0 && offer.city != 'Non spécifié' && offer.city != 'Not specified'"
                class="flex items-center space-x-2"
            >
                <IconMapPin :size="16" class="text-gray-500" />
                <span class="font-medium">{{ offer.city }}</span>
            </div>

            <div v-if="offer.availability" class="flex items-center space-x-2">
                <IconClock24 :size="16" class="text-gray-500" />
                <span class="font-medium">{{ offer.availability }}</span>
            </div>
        </div>

        <div class="flex flex-1 items-end justify-center">
            <img loading="lazy" :src="offer.company?.logo" alt="" class="hidden h-32 w-64 object-contain md:block" />
        </div>
    </a>

    <a
        v-else
        :href="$page.props.locale == 'fr' ? `/emplois/${offer.slug}` : `/en/job-opportunities/${offer.slug}`"
        class="group flex flex-col space-y-6 rounded-md border bg-white p-6 shadow"
        :class="[
            offer.is_promoted ? 'border-t-4 border-green-600 hover:border-t-4 hover:border-green-600' : '',
            offer.is_highlighted ? `border-2` : '',
        ]"
        :style="
            offer.is_highlighted
                ? {
                      'box-shadow': `0 20px 25px -5px ${offer.highlight_colour}, 0 8px 10px -6px ${offer.highlight_colour}`,
                      'border-color': `${offer.highlight_colour}`,
                  }
                : {}
        "
        target="_blank"
        rel="noopener noreferrer"
    >
        <div>
            <a
                :href="$page.props.locale == 'fr' ? `/emplois/${offer.slug}` : `/en/job-opportunities/${offer.slug}`"
                class="block text-2xl font-bold leading-tight hover:underline"
                target="_blank"
                rel="noopener noreferrer"
            >
                {{ title }}
            </a>

            <InertiaLink
                :href="
                    $page.props.locale == 'fr'
                        ? `/emplois?entreprise=${offer.company_slug}`
                        : `/en/job-opportunities?entreprise=${offer.company_slug}`
                "
                class="font-semibold hover:underline"
            >
                {{ offer.company_name }}
            </InertiaLink>
        </div>

        <div class="flex flex-col space-y-1 text-gray-600">
            <div
                v-if="offer.city && offer.city.length > 0 && offer.city != 'Non spécifié' && offer.city != 'Not specified'"
                class="flex items-center space-x-2"
            >
                <IconMapPin :size="16" class="text-gray-500" />
                <span class="font-medium">{{ offer.city }}</span>
            </div>

            <div v-if="offer.availability" class="flex items-center space-x-2">
                <IconClock24 :size="16" class="text-gray-500" />
                <span class="font-medium">{{ offer.availability_fr }}</span>
            </div>
        </div>

        <div class="flex flex-1 items-end justify-center">
            <img loading="lazy" :src="offer.company_logo" alt="" class="hidden h-32 w-64 object-contain md:block" />
        </div>
    </a>
</template>

<script setup>
    import { usePage } from '@inertiajs/inertia-vue3';
    import { IconClock24, IconMapPin } from '@tabler/icons-vue';
    import { computed } from 'vue';

    const props = defineProps({
        offer: Object,
        isSubdomain: {
            type: Boolean,
            default: false,
        },
    });

    const title = computed(() => {
        if (usePage().props.value.locale == 'fr') {
            return props.offer.title_fr?.length ? props.offer.title_fr : props.offer.title_en;
        } else {
            return props.offer.title_en?.length ? props.offer.title_en : props.offer.title_fr;
        }
    });
</script>
